import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";

export const cognitoIdentityProviderClient = new CognitoIdentityProviderClient({
  region: "eu-west-2",
});
